import { gql } from '@apollo/client';
import { COURSE_FIELDS } from "./course";
import { PROGRAM_RECORD_FIELDS, TRAINING_PROGRAM_FIELDS } from "./training-program";
export const STUDENT_PROGRAM_RECORD_FIELDS = gql`
  ${COURSE_FIELDS}
  ${TRAINING_PROGRAM_FIELDS}
  fragment StudentProgramRecordFields on StudentProgramRecordDto {
    id
    name
    businessUnitId
    businessUnitName
    creationTimestamp
    createdBy
    modifiedBy
    timestamp
    delegation {
      id
      name
      structure
    }
    trainingProgram {
      ...TrainingProgramFields
    }
    pendingCourses {
      ...CourseFields
    }
  }
`;
export const STUDENT_FIELDS = gql`
  ${PROGRAM_RECORD_FIELDS}
  fragment StudentFields on StudentDto {
    id
    name
    businessUnitId
    businessUnitName
    creationTimestamp
    createdBy
    modifiedBy
    timestamp
    code
    status
    works
    externalId
    largeFamily
    specialNeeds
    highCapacities
    topLevelAthlete
    numberBrothers
    programRecords {
      ...ProgramRecordFields
    }
  }
`;